import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Utils } from '../services/utils.service';
import { EnrollmentButtonComponent } from '../enrollment-button/enrollment-button.component';

@Component({
    selector: 'app-send-to-ease-modal',
    templateUrl: './send-to-ease-modal.component.html',
    styleUrls: ['./send-to-ease-modal.component.scss']
})
export class SendToEaseModalComponent {
    public cookieValue: string;
    constructor(
        public utils: Utils,
        private dialogRef: MatDialogRef<SendToEaseModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EnrollmentButtonComponent) { }

    onSyncClick(): void {
        this.dialogRef.close();
        console.log("Redirecting to AWS DashBoard");
        var awsUrl = this.data.awsRedirectUrl;
        console.log("Aws URL -> " + awsUrl);
        if (awsUrl == null || awsUrl === '') {
            window.top.location.href = 'https://www.agencyworkspace.com/';
        } else {
            window.top.location.href = awsUrl;
        }
        console.log("Redirected To AWS DashBoard");
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
